import { BaseRecord } from "./base";

export class Phone extends BaseRecord{
    coll_ref: string = "phones"
    userId: string
}